import React, { useState, useEffect, useMemo , useRef} from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import "../../assets/css/inventorymanagement.css"
import { indianDateTimeISO as getTime } from '../indiandatetimeiso';

const SKUMaster = () => {
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [editFormData, setEditFormData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
    sku_weight_grams:"",
    case_size:"",
    unit_cost:""
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
    sku_weight_grams:"",
    case_size:"",
    unit_cost:""
  });
  const columnWithDefs = [
  {
    headerName: "",
    field: "actions",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => (
      <div
        style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}
      >
        <button
          title="Edit"
          className="mt-2"
          style={{
            height: "30px", 
            width: "60px",  // Adjust width to ensure the button fits
            padding: "0 10px",  // Optional: Adjust padding for appearance
            border: "1px solid #93385D",
            borderRadius: "4px",
            cursor: "pointer",
            backgroundColor: "#F4EBEF",  // Optional: Customize the background color
            fontSize: "0.8rem",  // Optional: Adjust font size for readability
            color: "#93385D" // Optional: Customize button text color;
          }}
          onClick={() => handleEdit(params.data)}
        >
          Edit
        </button>
      </div>
    ),
  },
  {
    headerName: "",
    field: "delete",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => (
      <div style={{
        height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
      }}>
          <button
              title="Delete"
              style={{
                height: "30px",
                width: "60px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => handleDelete(params.data)}
            >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
      </div>
    
    ),
  },
  {
    headerName: "SKU Code",
    field: "sku_code",
    //tooltipField: "sku_code",
    sortable: true,
    resizable: true,
    // width : "200px",
    // flex: 1,
  },
  {
    headerName: "SKU Name",
    field: "sku_name",
    //tooltipField: "sku_name",
    sortable: true,
    resizable: true,
    // width : "360px"
  },
  // {
  //   headerName: "SKU Weight (gms)",
  //   field: "sku_name",
  //   sortable: true,
  //   resizable: true,
  //     width: "150px",
  //     valueGetter: (params) => {
  //       if (params.data.sku_weight_grams) {
  //         return params.data.sku_weight_grams
  //       }
  //       else {
  //         const skuName = params.data?.sku_name;

  //         if (!skuName) return null;

  //         const skuNameLower = skuName.toLowerCase();

  //         // Patterns to match weight values
  //         const gmsPattern = /([\d.]+)\s*gms?/;
  //         const kgPattern = /([\d.]+)\s*kg/;
  //         const gPattern = /([\d.]+)\s*g\b/;

  //         let match;
  //         let weight;
  //         let unit;

  //         // Search in order: gms -> kg -> G
  //         if ((match = skuNameLower.match(gmsPattern))) {
  //           weight = match[1];
  //           unit = "g";
  //         } else if ((match = skuNameLower.match(kgPattern))) {
  //           weight = match[1];
  //           unit = "kg";
  //         } else if ((match = skuNameLower.match(gPattern))) {
  //           weight = match[1];
  //           unit = "g";
  //         }

  //         if (weight) {
  //           const weightNum = parseFloat(weight);
  //           if (!isNaN(weightNum)) {
  //             // Convert everything to grams
  //             if (unit === "kg") {
  //               return weightNum * 1000; // Convert kg to grams
  //             } else {
  //               return weightNum; // Already in grams
  //             }
  //           }
  //         }

  //         return null;
  //       }
  //     },
  //     valueFormatter: (params) => {
  //       if (params.value === null || params.value === undefined) return "N/A";

  //       // Return just the numeric value for display (no "g")
  //       return params.value.toString();
  //     }
  // },
  {
    headerName: "SKU Weight (gms)",
    field: "sku_weight_grams",
    sortable: true,
    resizable: true,
    width: 150,
    valueGetter: (params) => {
      const val = params?.data?.sku_weight_grams;
      if (isNaN(val)) return "N/A";  // show “N/A” if weight not found
      return val         // otherwise show numeric value
    }
  },
  {
    headerName: "SKU Category",
    field: "sku_category",
    //tooltipField: "sku_category",
    sortable: true,
    resizable: true,
    // flex: 1,

  },
    {
    headerName: "Unit Of Measure",
    field: "unit_of_measure",
    //tooltipField: "unit_of_measure",
    sortable: true,
    resizable: true,
    // flex: 1,

  },
  {
    headerName: "Minimum Order Quantity (Units)",
    field: "minimum_order_quantity",
    //tooltipField: "minimum_order_quantity",
   

  },
    {
    headerName: "Case Size",
    field: "case_size",
    //tooltipField: "case_size",
    sortable: true,
    resizable: true,
    minWidth: 150,
    flex: 1,
  },
   {
    headerName: "Unit Cost",
    field: "unit_cost",
    sortable: true,
    resizable: true,
    minWidth: 150,
    flex: 1,
  },
  // {
  //   headerName: "Date Time IST",
  //   field: "created_date",
  //   //tooltipField: "case_size",
  //   sortable: true,
  //   resizable: true,
  //   // flex: 1,
  //   valueGetter: (params) => {
  //     return getTime({  date : params.data.created_date, datePart: true   });
  //   }
  // },
];


  const resetFormData = () => {
    setEditFormData({ 
      sku_code: "",
      sku_name: "",
      sku_category: "",
      unit_of_measure: "",
      minimum_order_quantity: "",
      weight:"",
      sku_weight_grams: "", 
    case_size: "",         
    unit_cost: ""          
    });
    setDuplicatedEditData({
      sku_code: "",
      sku_name: "",
      sku_category: "",
      unit_of_measure: "",
      minimum_order_quantity: "",
      weight:"", sku_weight_grams: "", 
    case_size: "",         
    unit_cost: ""          
    });
  };
  
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData()
    setUploadedFileData([]);
  };

  const onClickAddNewProduct = () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1)
    setSliderCl("slider-25");
    setSliderTitle("Add New Product");
    setOverlyBlock("show-m");
  };

    const handleEdit = (row) => {
    console.log(row)
    setSliderOpen(true);
    setSliderType(3); 
    setSliderCl("slider-25");
    setSliderTitle(`Edit Product - ${row.sku_code}`);
    setOverlyBlock("show-m");
    const editFormData ={
      sku_code: row.sku_code || "",
      sku_name: row.sku_name || "",
      sku_category: row.sku_category || "",
      unit_of_measure: row.unit_of_measure || "",
      minimum_order_quantity: row.minimum_order_quantity || "",
      sku_weight_grams: row.sku_weight_grams || "",
      case_size: row.case_size || "",
      unit_cost: row.unit_cost || ""
    }
    setEditFormData(editFormData);  

    console.log("editFormData", editFormData)


    setDuplicatedEditData({
      sku_code: row.sku_code || "",
      sku_name: row.sku_name || "",
      sku_category: row.sku_category || "",
      unit_of_measure: row.unit_of_measure || "",
      minimum_order_quantity: row.minimum_order_quantity || "",
      sku_weight_grams: row.sku_weight_grams || "",
      case_size: row.case_size || "",
      unit_cost: row.unit_cost || ""
    });
  };

  console.log("editFormData", editFormData)

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
   
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }
  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("masters/getSkuMasterData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setTimeout(() => autoSizeAllColumns(), 100);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No SKU master data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching SKU master data:", error);
      setBasicTitle("Failed to fetch SKU master data");
      setBasicType("error");
      setShow(true);
    }
  }
  useEffect(() => {
    const getData = async () => {
      setLoadshow("show-m");  
      setOverlayBlock("show-m");
        await getSkuMasterData()
      setLoadshow("show-n");  
      setOverlayBlock("show-n");
      }
    getData()

  }, []);


const closeAlert = () => {
 const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }

  setUploadedFileData([]);
  // setFile(null)
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
  setShowDeletePopup(false)
  setSliderOpen(false)

  resetFormData();
};

const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Product Code",
        "Product Name",
        "Unit Of Measure",
        "Sku Category",
        "Minimum Order Quantity",
        "SKU Weight (gms)",
        "Case Size",
        "Unit Cost", 
      ],
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_master_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });
        // mapping config
        const mapping = {
          "Product Code": "sku_code",
          "Product Name": "sku_name",
          "Product Category": "sku_category",
          "Unit Of Measure" : "unit_of_measure",
          "Minimum Order Quantity": "minimum_order_quantity",
          "SKU Weight (gms)": "sku_weight_grams",
          "Case Size": "case_size",
          "Unit Cost": "unit_cost"
        };

        function toSnakeCase(str) {
          return str
            .trim()
            .replace(/\s+/g, '_')           // replace spaces with underscores
            .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
            .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
        }

        // transform
        const result = parsedData.map(item => {
          const newItem = {};
          for (const key in item) {
            if (mapping[key]) {
              // if in mapping use mapped version
              newItem[mapping[key]] = item[key];
            } else {
              // if not in mapping, convert key to snake_case
              newItem[toSnakeCase(key)] = item[key];
            }
          }
          return newItem;
        });


      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };
  
  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }
    const params = { masterData: uploadedFileData };
      try {
        const response = await redirectURL.post(
          "masters/storeSkuMasterData",
          params
        );
       
        if (response.data.status === "success") {
          await getSkuMasterData();
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("success");
          setBasicTitle("Data Uploaded Successfully");
          // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New SKU Uploaded",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("info");
          setBasicTitle("Data Upload Failed");
          // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New SKU Uploaded",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
        }
        
      } catch (error) {
        console.log({error});
        const errorData = error.response.data
        console.log("")
        setShow(true);
        setBasicType("info");
        setBasicTitle(errorData.message);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New SKU Uploaded",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      
      }
  };


  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Upload SKU Master Data");
    setOverlyBlock("show-m");
  };

  const onClickingUpdateSkuData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {  
      sku_code: editFormData.sku_code,
      sku_name: editFormData.sku_name,
      sku_category: editFormData.sku_category,
      unit_of_measure: editFormData.unit_of_measure,
      minimum_order_quantity: parseInt(editFormData.minimum_order_quantity),
      sku_weight_grams: parseInt(editFormData.sku_weight_grams),
      case_size: parseInt(editFormData.case_size),
      unit_cost: parseInt(editFormData.unit_cost)
    };  

    const isNeedtoUpdate = Object.keys(editFormData).filter(
    (key) => editFormData[key] !== duplicatedEditData[key] && editFormData[key] !== ""
    )
    if ( isNeedtoUpdate.length === 0){
      setShow(true);
      setBasicType("info");
      setBasicTitle("No changes made to SKU data");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/updateSkuMasterData",
        params
      );
      if (response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("SKU Data Updated Successfully");
        // Update the rowData with the new data
        const updatedRowData = rowData.map((row) =>
          row.sku_code === editFormData.sku_code ? editFormData : row
        );
        setRowData(updatedRowData);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "SKU Edited",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to update SKU data");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "SKU Edited",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
      
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update SKU data");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "SKU Edited",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const handleAddSkuProduct = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {
      sku_code: editFormData.sku_code,
      sku_name: editFormData.sku_name,
      sku_category: editFormData.sku_category,
      unit_of_measure: editFormData.unit_of_measure,
      minimum_order_quantity: parseInt(editFormData.minimum_order_quantity),
      sku_weight_grams: parseInt(editFormData.sku_weight_grams),
      case_size: parseInt(editFormData.case_size),
      unit_cost: parseInt(editFormData.unit_cost)
      
    };
    console.log("params", params)

    const validationErrors = Object.keys(params).filter((key) => {
      const value = params[key];
      // Apply trim only for string fields
      if (typeof value === "string") {
        return !value || value.trim() === "";
      } else if (value === undefined || value === null || value === "") {
        return true;
      }
      return false;
    });

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    const validSkuCode = /^[a-zA-Z0-9_-]+$/.test(params.sku_code);  
    const validatemoq = /^[0-9]+$/.test(params.minimum_order_quantity);
    
    if (!validatemoq) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Minimum Order Quantity must be a valid number");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    if (!validSkuCode) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("SKU Code can only contain letters, numbers, underscores, and hyphens");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/addSkuProduct",
        params
      );
   
      if (response.status === 200 && response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("SKU Product Added Successfully");
        setRowData((prevRowData) => [...prevRowData, params]);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New SKU Added",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here

      } else {
         setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to add SKU Product");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New SKU Added",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
     
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to add SKU Product");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "New SKU Added",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { sku_code: selectedRow.sku_code };
    try { 
      const response = await redirectURL.post(
        "masters/deleteSKU",
        params
      );
      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("SKU Product Deleted Successfully");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "SKU Deleted",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
          setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete SKU Product");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "SKU Deleted",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete SKU Product");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "SKU Deleted",
          status: "Failure",
          path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }


  };

  const onClickDeletePopupCancelBtn = () => {
      setOverlayBlock("show-n");
      setShowDeletePopup(false);
  };
  
  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>SKU Master</h1>
          </div>
          <div style={addButtonContainerStyle} className="col-sm-12 text-right pr-0 mb-4">
              <button 
              onClick={onClickAddNewProduct}
              style={{
                ...addButtonStyle,
                  backgroundColor: "#93385D",
                  color: "#fff",
                  border: "2px solid #93385D",
                  marginRight: 15
              }}
              >
              <IoMdAdd style={{color : "#fff", fontSize :"18px"}}/>
                {" Add"}
              </button>
              <button
              onClick={onClickUploadSkuMasterData}

                className="mr-2"
                style={{
                  ...addButtonStyle,
                  backgroundColor: "#F4EBEF",
                  color: "#93385D",
                  border: "2px solid #93385D",
                }}
            >
              < MdOutlineFileUpload style={{color : "#93385D", fontSize :"18px"}}/>
              
              {" Upload"}
            </button>
            </div>
            <div className="col-sm-12 p-0 pl-2 mt-6">
              <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={100}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                    onGridReady={onGridReady}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{width : "25%"}}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
          
        </div>

      {sliderType === 1 && (
        <form style={{ padding: "20px" }}> 
            <div className="form-group">
              <label htmlFor="SkuCode" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Product Code <span style={{color :"red"}}>*</span></label>
              <div id="SkuCode" >
                <input
                  type="text"
                  className="form-control"
                  id="sku_code"
                  pattern="[a-zA-Z0-9_-]+"
                  name="sku_code"
                  onChange={(e) => setEditFormData({ ...editFormData, sku_code: e.target.value })}
                  value={editFormData.sku_code}
                  placeholder="Enter SKU Code"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  required
                  title="SKU Code can only contain letters, numbers, underscores, and hyphens"
                  autoComplete="off"

                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="SkuName" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Product Name <span style={{color :"red"}}>*</span></label>
              <div id="SkuName" >
                <input
                  type="text"
                  className="form-control"
                  id="sku_code"
                  name="sku_code"
                  placeholder="Enter SKU Code"
                  onChange={(e) => setEditFormData({ ...editFormData, sku_name: e.target.value })}
                  value={editFormData.sku_name}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"

                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="SkuCategory" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Product Category <span style={{color :"red"}}>*</span></label>
              <div id="SkuCategory" >
                <input
                  type="text"
                  className="form-control"
                  id="sku_code"
                  name="sku_code"
                  placeholder="Enter SKU Code"
                  onChange={(e) => setEditFormData({ ...editFormData, sku_category: e.target.value })}
                  value={editFormData.sku_category}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"

                />
              </div>

            </div>
            <div className="form-group">
              <label htmlFor="UnitOfMeasure" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Unit Of Measure <span style={{color :"red"}}>*</span></label>  
              <div id="UnitOfMeasure" >
                <input
                  type="text"
                  className="form-control"  
                  id="uom"
                  name="uom"
                  placeholder="Enter UOM"

                  onChange={(e) => setEditFormData({ ...editFormData, unit_of_measure: e.target.value })}
                  value={editFormData.unit_of_measure}
                  style={{
                    width: "100%",  
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"

                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="Weight" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Sku Weight <span style={{color :"red"}}>*</span></label>
              <div id="Weight" >
                <input
                  type="number"
                  pattern="[0-9]+"
                  className="form-control"
                  id="sku_code"
                  name="sku_code"
                  placeholder="Enter SKU Code"
                  onChange={(e) => setEditFormData({ ...editFormData, sku_weight_grams: e.target.value })}
                  value={editFormData.sku_weight_grams}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="MinimumOrderQuantity" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Minimum Order Quantity <span style={{color :"red"}}>*</span></label>
              <div id="MinimumOrderQuantity" >
                <input
                  type="number"
                  pattern="[0-9]+"
                  className="form-control"
                  id="sku_code"
                  name="sku_code"
                  placeholder="Enter SKU Code"
                  onChange={(e) => setEditFormData({ ...editFormData, minimum_order_quantity: e.target.value })}
                  value={editFormData.minimum_order_quantity}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="CaseSize" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Case Size<span style={{color :"red"}}>*</span></label>
              <div id="CaseSize" >
                <input
                  type="number"
                  pattern="[0-9]+"
                  className="form-control"
                  id="sku_code"
                  name="sku_code"
                  placeholder="Enter SKU Code"
                  onChange={(e) => setEditFormData({ ...editFormData, case_size: e.target.value })}
                  value={editFormData.case_size}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="UnitCost" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Unit Cost<span style={{color :"red"}}>*</span></label>
              <div id="UnitCost" >
                <input
                  type="number"
                  pattern="[0-9]+"
                  className="form-control"
                  id="sku_code"
                  name="sku_code"
                  placeholder="Enter SKU Code"
                  onChange={(e) => setEditFormData({ ...editFormData, unit_cost: e.target.value })}
                  value={editFormData.unit_cost}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>
            </div>
            <div style={{
              textAlign: "right",
              marginTop: "10px"
            }}>
                <button
                type="submit"
                id = "sample-download-button"
                // className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  handleAddSkuProduct();
                }}
              >
                ADD
              </button>
            </div>
        </form>
      )}

      {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
              <div className="d-flex justify-content-end mb-10p">
                <button
                  id = "sample-download-button"
                  onClick={downloadExcelTemplate}
                >
                  {"Download Sample Template"}
                  {/* Download Sample Template */}
                </button>
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                // value={file}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  onClick={onClickingFileSubmit}
                >
                  {"Submit"}
                </button>
              </div>
             

            </div>
          </div>
      )}
      {sliderType === 3 && (
        <form style={{ padding: "20px" }} 
          onSubmit={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onClickingUpdateSkuData();
          }}
          >
          <div className="form-group">
              <label
                htmlFor="sku_code"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "5px",
                  display: "block",
                }}
              >
                Product Code <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sku_code"
                name="sku_code"
                value={editFormData.sku_code}
                onChange={(e) =>
                  setEditFormData({ ...editFormData, sku_code: e.target.value })
                }
                placeholder="Enter SKU Code"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "0.9rem",
                  backgroundColor: "#f9f9f9",
                  cursor: "not-allowed",
                }}
                disabled  // ⬅️ this makes the field read-only
                required
              />
          </div>

          <div className="form-group">
            <label htmlFor="sku_name" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Product Name <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="sku_name"
              name="sku_name"
              value={editFormData.sku_name}
              onChange={(e) => setEditFormData({ ...editFormData, sku_name: e.target.value })}
              placeholder="Enter SKU Name"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="sku_category" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Product Category <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="sku_category"
              name="sku_category"
              value={editFormData.sku_category}
              onChange={(e) => setEditFormData({ ...editFormData, sku_category: e.target.value })}
              placeholder="Enter Product Category"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
            </div>
            <div className="form-group">
            <label htmlFor="unit_of_measure" style={{   
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Unit Of Measure <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="unit_of_measure"  
              name="unit_of_measure"
              value={editFormData.unit_of_measure}
              onChange={(e) => setEditFormData({ ...editFormData, unit_of_measure: e.target.value })}
              placeholder="Enter Unit Of Measure"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="weight" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Sku Weight <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="weight"
              name="weight"
              value={editFormData.sku_weight_grams}
              onChange={(e) => setEditFormData({ ...editFormData, sku_weight_grams: e.target.value })}
              placeholder="Enter Weight"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="minimum_order_quantity" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Minimum Order Quantity <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="minimum_order_quantity"
              name="minimum_order_quantity"
              value={editFormData.minimum_order_quantity}
              onChange={(e) => setEditFormData({ ...editFormData, minimum_order_quantity: e.target.value })}
              placeholder="Enter Minimum Order Quantity"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>



           <div className="form-group">
            <label htmlFor="case_size" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Case Size<span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="case_size"
              name="case_size"
              value={editFormData.case_size}
              onChange={(e) => setEditFormData({ ...editFormData, case_size: e.target.value })}
              placeholder="Enter Case Size"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div> <div className="form-group">
            <label htmlFor="UnitCost" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Unit Cost<span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="UnitCost"
              name="UnitCost"
              value={editFormData.unit_cost}
              onChange={(e) => setEditFormData({ ...editFormData, unit_cost: e.target.value })}
              placeholder="Enter Minimum Order Quantity"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div style={addButtonContainerStyle}>
            <button
              type="submit"
              id = "sample-download-button"
              // className="btn btn-success"
              // style={addButtonStyle}
              
            >
              Update
            </button> 
          </div>
    </form>
    )}
      </div>
           {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to delete ${selectedRow ? selectedRow.sku_code : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
               Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
        <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </>
  );
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px", gap : 20 };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

export default SKUMaster;
